export const ProductionConfig = {
  DEBUG: false,
  FRONTDESK_URL: "https://frondesq.com",
  PORT: process.env.PORT ? process.env.PORT : 3005,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD,
  PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_PROD,
  PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK_SECRET_KEY_PROD,
  CSC_API_KEY: process.env.REACT_APP_CSC_API_KEY,
}
